import styled from 'styled-components'

export const ModalTitle = styled.div`
	margin: 0 0 0.75em;
	font-size: 1.2em;
	font-weight: ${(p) => p.theme.font.sans.weight.bold};
`
